import React, { Component } from "react";
import PropTypes from "prop-types";
import { FORM_FIELD_TYPE } from "../../../../constants";
import RightPanel from "../../../common/RightPanel";
import Form from "../../../common/Form";

export default class EditAdvertiserType extends Component {
  constructor(props) {
    super(props);
    this.state = {
      advertiserType: this.props.advertiserType,
      hasEditError: false,
    };
  }

  static propTypes = {
    advertiserType: PropTypes.object.isRequired,
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
  };

  componentDidUpdate(prevProps) {
    if (this.props.advertiserType !== prevProps.advertiserType)
      this.setState({ advertiserType: this.props.advertiserType });
  }

  cancelEdit = () => {
    this.setState({ hasEditError: false });
    this.props.onClose();
  };

  isValid = (advertiserType) => {
    if (advertiserType.name.trim().length === 0) return false;
    if (!advertiserType.rank) return false;
    return true;
  };

  save = () => {
    const { advertiserType } = this.state;
    if (!this.isValid(advertiserType)) return this.setState({ hasEditError: true });
    this.props.onSave(advertiserType);
    this.cancelEdit();
  };

  inputOnChange = (value, accessor) => {
    const { advertiserType } = this.state;
    this.setState({
      advertiserType: { ...advertiserType, [accessor]: value },
    });
  };
  inputNumberChange = (value, accessor) => {
    const { advertiserType } = this.state;
    if (!isNaN(value)) {
      this.setState({
        advertiserType: { ...advertiserType, [accessor]: Number(value) },
      });
    }
  };
  render = () => {
    const { isOpen } = this.props;
    const { advertiserType = {}, hasEditError } = this.state;
    return (
      <RightPanel
        isOpen={isOpen}
        onClose={() => this.cancelEdit()}
        header={
          advertiserType.id
            ? "RightPanelHeader.editAdvertiserType"
            : "RightPanelHeader.addAdvertiserType"
        }
        showFooter={true}
        isEdit={advertiserType.id ? true : false}
        primaryButtonProps={{ text: "Button.save", onClick: this.save }}
        secondaryButtonProps={{ text: "Button.cancel", onClick: this.cancelEdit }}
      >
        <Form
          config={[
            {
              type: FORM_FIELD_TYPE.INPUT,
              label: "Name",
              className: "col-12",
              placeholder: "Enter Name",
              value: advertiserType.name,
              error: hasEditError && advertiserType.name.trim().length === 0,
              errorMessage: "Enter Valid Name",
              onChange: (e) => this.inputOnChange(e.target.value, "name"),
            },
            {
              type: FORM_FIELD_TYPE.INPUT,
              label: "Order",
              className: "col-12",
              placeholder: "Enter Order",
              value: advertiserType.rank,
              error: hasEditError && !advertiserType.rank,
              errorMessage: "Enter Valid order",
              onChange: (e) => this.inputNumberChange(e.target.value, "rank"),
            },
          ]}
        />
      </RightPanel>
    );
  };
}
